import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-newsletter-subscription]')) return;
  dataLayerSubmitOnDesktop();

  if (!$('[data-au-newsletter-subscription-banner]')) return;
  newsletterBannerToggleVisibility();
}

/**
 *
 * Functions to:
 *
 * toggle visibility of sticky banner
 * scroll to newsletter form when click on sticky banner button
 */
function newsletterBannerToggleVisibility() {
  const newsletterBanner = $('[data-au-newsletter-subscription-banner]');
  const newsletterForm = $('[data-au-newsletter-subscription]');
  const footer = $('#main-footer');
  if (!newsletterBanner || !newsletterForm) return;

  window.addEventListener('scroll', function () {
    const newsletterBannerTop = newsletterForm.getBoundingClientRect().top + window.scrollY;
    const newsletterBannerBottom = newsletterBannerTop + newsletterForm.offsetHeight;
    const footerTop = footer ? footer.getBoundingClientRect().top + window.scrollY : 0;
    const footerBottom = footer ? footerTop + footer.offsetHeight : 0;
    const viewportTop = window.scrollY;
    const viewportBottom = viewportTop + window.innerHeight;

    if (
      (newsletterBannerBottom > viewportTop && newsletterBannerTop < viewportBottom) ||
      (footerBottom > viewportTop && footerTop < viewportBottom)
    ) {
      newsletterBanner.classList.add('au-newsletter-subscription--hidden');
    } else {
      newsletterBanner.classList.remove('au-newsletter-subscription--hidden');
    }
  });

  // scroll to newsletter form
  const newsletterAnchor = $('[data-au-newsletter-subscription-anchor]');
  newsletterAnchor.addEventListener('click', (e) => {
    const targetId = e.target.dataset.auNewsletterSubscriptionAnchor;
    const target = $(`[data-au-module-id=${targetId}]`);
    const newsletterFormTop = target.offsetTop;
    const headerHeight = $('.n-main-header-responsive').offsetHeight;
    window.scrollTo(0, newsletterFormTop - headerHeight);

    // if some focusable element on target, focus on first of them
    const focusableElemets =
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)';
    target.querySelectorAll(focusableElemets).forEach((focusableElement, index) => {
      if (!focusableElement) return;

      if (index === 0) {
        focusableElement.focus();
      }
    });
  });
}

function dataLayerSubmitOnDesktop() {
  $$('[data-au-newsletter-subscription-search] [data-au-search-bar-button]').forEach((input) => {
    input.addEventListener('click', (e) => {
      const titleText = e.target.closest('section').querySelector('[data-au-title]').innerText;
      const clickText = e.target.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id,
      });
    });
  });
}

export default { init };
